export { default as SvgSDM17SPG } from './SvgSDM17SPG';
export { default as SvgSDM18MVR } from './SvgSDM18MVR';
export { default as SvgSDM18HCL } from './SvgSDM18HCL';
export { default as SvgRemote } from './SvgRemote';
export { default as SvgUser } from './SvgUser';
export { default as SvgCraftsman } from './SvgCraftsman';
export { default as SvgTicket } from './SvgTicket';
export { default as SvgProduct } from './SvgProduct';
export { default as SvgSDM18SP2 } from './SvgSDM18SP2';
export { default as SvgSDM17DEC } from './SvgSDM17DEC';
export { default as SvgSDM18HCN } from './SvgSDM18HCN';
export { default as SvgAirzone } from './SvgAirzone';
export { default as SvgSmokeDetector } from './SvgSmokeDetector';
export { default as ApplianceIconComponent } from './ApplianceIconComponent';
export { default as SvgSDM17SPGIcon } from './SvgSDM17SPGInstall';
export { default as SvgSDM18HCLIcon } from './SvgSDM18HCLInstall';
export { default as SvgSDM18HCNIcon } from './SvgSDM18HCNInstall';
export { default as SvgSDM17SPTIcon } from './SvgSDM17SPTInstall';
export { default as SvgSDM16SPMIcon } from './SvgSDM16SPMInstall';
export { default as SvgSDM17DECIcon } from './SvgSDM17DECInstall';
export { default as SvgSDM19DEEIcon } from './SvgSDM19DEEInstall';
export { default as SvgSDM19DE2Icon } from './SvgSDM19DE2Install';
export { default as SvgSDM19STMIcon } from './SvgSDM19STMInstall';
export { default as SvgSecurityModemIcon } from './SvgSecurityModem';
export { default as SvgSDM18SP2Icon } from './SvgSDM18SP2Install';
export { default as SvgSDM18MVRIcon } from './SvgSDM18MVRInstall';
export { default as SvgAirzoneIcon } from './SvgAirzoneInstall';
export { default as WifiIcon } from './SvgWifiIcon';
export { default as SvgBox } from './SvgBox';
export { default as SvgHome } from './SvgHome';
export { default as FlagFr } from './FlagFr';
export { default as FlagEn } from './FlagEn';
export { default as FlagDe } from './FlagDe';
export { default as SvgManagement } from './SvgManagement';
export { default as SvgDistrict } from './SvgDistrict';
export { default as SvgApartments } from './SvgApartments';
export { default as SvgHistory } from './SvgHistory';
export { default as SvgJournalisation } from './SvgJournalisation';
export { default as SvgSDM20LHT } from './SvgSDM20LHT';
export { default as SvgSecurity } from './SvgSecurity';



// WEBPACK FOOTER //
// ./data/common/iconsvg/index.js